import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import JacksonDetailedAccount from './JacksonDetailedAccount';

class JacksonDetailedAccountModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }

  handleShow() {
    this.setState({ show: true, });
  }

  handleClose() {
    this.setState({ show: false, });
  }

  render() {
    const { show, } = this.state;
    const { account, } = this.props;
    let view = null;
    if (show) {
      view = <JacksonDetailedAccount account={account} />;
    }
    return (
      <>
        <Button variant="primary" onClick={() => this.handleShow()}>
          Details
        </Button>

        <Modal show={show} onHide={() => this.handleClose()} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>{`Jackson Tax Account Id: ${account.id}`}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{view}</Modal.Body>
        </Modal>
      </>
    );
  }
}

JacksonDetailedAccountModal.propTypes = {
  account: PropTypes.instanceOf(Object).isRequired,
};

export default JacksonDetailedAccountModal;
